<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="8" :sm="24">
            <a-form-item label="关键字">
              <a-input v-model="queryParam.keywords" allowClear placeholder="搜索关键字"/>
            </a-form-item>
          </a-col>
          <a-col :md="8" :sm="24">
            <a-form-item label="所属活动">
              <a-select v-model="queryParam.activity_id" placeholder="请选择"
                        allowClear>
                <a-select-option v-for="(option,index) in activityOptions" :value="option.id">
                  {{ option.title }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="8" :sm="24">
            <a-form-item label="素材类型">
              <a-select v-model="queryParam.type" placeholder="请选择素材类型"
                        allowClear>
                <a-select-option value="1">图片</a-select-option>
                <a-select-option value="2">视频</a-select-option>
                <a-select-option value="3">VR直播</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="8" :sm="24">
            <a-form-item label="状态">
              <a-select v-model="queryParam.status" placeholder="请选择状态"
                        allowClear>
                <a-select-option value="1">审核通过</a-select-option>
                <a-select-option value="2">待审核</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="8" :sm="24">
            <a-form-item
                label="省市筛选"
            >
              <a-cascader
                  :options="cityOptions"
                  placeholder="省市筛选"
                  v-model="area_key"
                  change-on-select
              />
            </a-form-item>
          </a-col>

          <template v-if="advanced">
            <a-col :md="6" :sm="24">
              <a-form-item label="授权编号">
                <a-input v-model="queryParam.kaojiregist_code" placeholder="搜索授权编号"/>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="单位名称">
                <a-input v-model="queryParam.danwei" placeholder="搜索单位名称"/>
              </a-form-item>
            </a-col>


            <a-col :md="6" :sm="24">
              <a-form-item label="考试时间">
                <a-range-picker
                    v-model="time_range_moment"
                    style="width: 100%"
                    format="YYYY-MM-DD HH:mm:ss"
                    :showTime="{
                defaultValue: [moment('00:00:00', 'HH:mm:ss'), moment('23:59:59', 'HH:mm:ss')]
                }"
                />
              </a-form-item>
            </a-col>

          </template>
          <a-col :md="!advanced && 6 || 24" :sm="24">
            <span class="table-page-search-submitButtons"
                  :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
              <a-button type="primary" @click="onSearch">查询</a-button>
              <a-button style="margin-left: 8px" @click="() => queryParam = {}">重置</a-button>
              <a @click="toggleAdvanced" style="margin-left: 8px" v-if="false">
                {{ advanced ? '收起' : '展开' }}
                <a-icon :type="advanced ? 'up' : 'down'"/>
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <div class="table-operator">
      <a-button type="primary" icon="plus" @click="addHandle">新建</a-button>
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item @click="setAllStatus(1)" key="1">
            <a-icon type="check"/>
            审核通过
          </a-menu-item>
          <a-menu-item @click="setAllStatus(2)" key="2">
            <a-icon type="close"/>
            审核失败
          </a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px">
          批量操作
          <a-icon type="down"/>
        </a-button>
      </a-dropdown>
    </div>

    <s-table
        ref="table"
        size="default"
        :columns="columns"
        :data="loadData"
        :alert="{ show: true, clear: () => { this.selectedRowKeys = [] } }"
        :rowSelection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
    >
      <span slot="name" slot-scope="text,record">
          <div style="margin-left: 10px; float: left">
            {{ record.title }}
            <p style="color: #999">{{ record.desc }}</p>
            <div style="height: 100px; overflow: hidden" v-if="record.type !=3">
              <img :key="k" v-for="(pic,k) in record.pics_url" :src="pic" style="width: 100px ; margin-left: 10px"/>
            </div>
            发布时间 {{ record.create_time|timeFormat }}
            <br/>
            <a-badge status="success" v-if="record.status==1" text="审核通过"/>
            <a-badge status="processing" v-else-if="record.status==2" text="待审核"/>
          </div>
      </span>
      <span slot="rank" slot-scope="text,record">
        <template>
        <editable-cell :text="text" @change="onRankChange(record.id, 'rank', $event)"/>
        </template>
      </span>
      <span slot="user" slot-scope="text,record">
        <template>
          <div style="text-align: center;">
            <img :src="record.user_face" style="width: 30px;height: 30px;border-radius: 100%;" alt="">
            <div>{{record.user_name}}</div>
          </div>
        </template>
      </span>
      <span slot="action" slot-scope="text,record">
        <template>
          <a-popconfirm title="通过后不可恢复，是否通过吗?" v-if="record.status==2" @confirm="setStatus(record,1)" okText="确定"
                        cancelText="取消">
            <a href="javascript:;">通过审核</a>
          </a-popconfirm>
          <a-divider type="vertical" v-if="record.status==2"/>
          <a @click="handleEdit(record)">编辑</a>
          <a-divider type="vertical"/>
          <a-popconfirm title="删除后不可恢复,确定删除吗?" @confirm="onDelete(record)" okText="确定" cancelText="取消">
            <a href="javascript:;">删除</a>
          </a-popconfirm>
          <a-divider type="vertical"/>
          <a @click="handleCommentManage(record)">评论</a>

        </template>
      </span>
    </s-table>

    <a-modal
        title="操作"
        :width="1200"
        :bodyStyle="{maxHeight:'500px','overflowY':'scroll'}"
        v-model="visible"
        @ok="handleOk"
    >
      <a-spin :spinning="saveLoading">
        <a-form :form="form">
          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="标题"
                  hasFeedback
              >
                <a-input v-decorator="[
              'title',
              {rules: [{ required: true, message: '请输入动态标题' }]}
            ]"
                         placeholder="请输入标题"/>
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="素材类型"
                  hasFeedback
              >
                <a-radio-group v-model="formData.type">
                  <a-radio :value="1">图片</a-radio>
                  <a-radio :value="2">视频</a-radio>
                  <a-radio :value="3">VR</a-radio>
                </a-radio-group>
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24" v-if="formData.type == 1">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="图片"
                  hasFeedback
              >
                <pic-uploader
                    :numberLimit="9"
                    :multiple="true"
                    :file-list="formData.pics"
                />
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24" v-if="formData.type == 3">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="vr封面"
                  hasFeedback
              >
                <pic-uploader
                    :numberLimit="1"
                    :file-list="formData.vr_pic"
                />
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24" v-if="formData.type == 2">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="视频"
                  hasFeedback
              >
                <video-uploader
                    :numberLimit="1"
                    :file-list="formData.video"
                />
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24" v-if="formData.type == 3">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="VR"
                  hasFeedback
              >
                <a-input v-decorator="[
              'url',
            ]"
                         placeholder="请输入VR地址"/>
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="描述"
                  hasFeedback
              >
                <a-textarea v-decorator="[
              'desc',
              {rules: []}
            ]"
                            placeholder="请输入描述"/>
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">

              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="所属活动">
                <!--                                <a-select :disabled="formData.id>0" v-model="formData.activity_id" placeholder="请选择"  mode="multiple"-->
                <!--                                          allowClear>-->
                <!--                                    <a-select-option v-for="(option,index) in activityOptions" :value="option.id">-->
                <!--                                        {{option.title}}-->
                <!--                                    </a-select-option>-->
                <!--                                </a-select>-->
                <a-select v-model="formData.activity_id" placeholder="请选择所属活动" mode="multiple"
                          allowClear>
                  <a-select-option v-for="(option,index) in activityOptions" :value="option.id">
                    {{ option.title }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
<!--            <a-col :md="12" :sm="24">-->
<!--              <a-form-item-->
<!--                  :labelCol="labelCol"-->
<!--                  :wrapperCol="wrapperCol"-->
<!--                  label="发布用户"-->
<!--                  hasFeedback-->
<!--              >-->
<!--                <user-picker :formData="formData" field="user_id"/>-->
<!--              </a-form-item>-->
<!--            </a-col>-->
            <!--                        <a-col :md="12" :sm="24">-->
            <!--                            <a-form-item-->
            <!--                                    :labelCol="labelCol"-->
            <!--                                    :wrapperCol="wrapperCol"-->
            <!--                                    label="发布地点"-->
            <!--                                    hasFeedback-->
            <!--                            >-->
            <!--                                <a-input v-decorator="[-->
            <!--              'location_name',-->
            <!--            ]"-->
            <!--                                         placeholder="请输入发布地点（如：南京）"/>-->
            <!--                            </a-form-item>-->
            <!--                        </a-col>-->
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="悬赏金额"
                  hasFeedback
              >
                <a-select v-model="formData.reward_price" placeholder="请选择悬赏金额"
                          allowClear>
                  <a-select-option v-for="(option,index) in rewardOptions" :value="option.title">
                    {{ option.title }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
<!--            <a-col :md="12" :sm="24">-->
<!--              <a-form-item-->
<!--                  :labelCol="labelCol"-->
<!--                  :wrapperCol="wrapperCol"-->
<!--                  label="关联服务"-->
<!--                  hasFeedback-->
<!--              >-->
<!--                <a-select v-model="formData.goods_ids" placeholder="请选择关联服务" mode="multiple"-->
<!--                          allowClear>-->
<!--                  <a-select-option v-for="(option,index) in goodsOptions" :value="option.id">-->
<!--                    {{ option.title }}-->
<!--                  </a-select-option>-->
<!--                </a-select>-->
<!--              </a-form-item>-->
<!--            </a-col>-->
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="标签"
                  hasFeedback
              >
                <a-select v-model="formData.label" placeholder="请选择标签" mode="multiple"
                          allowClear>
                  <a-select-option v-for="(option,index) in labelOptions" :value="option.title">
                    {{ option.title }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>

            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="关闭评论"
                  hasFeedback
              >
                <r-switch :formData="formData" field="can_comment" :checkedValue="2" :unCheckedValue="1"
                          checkedChildren="关闭评论" unCheckedChildren="支持评论"/>
              </a-form-item>
            </a-col>
          </a-row>

          <a-row :gutter="48">
            <a-col :md="36" :sm="24">
              <a-form-item :labelCol="mapLabelCol" :wrapperCol="wrapperCol" label="发布地址" hasFeedback>
                <div class="amap-page-container">
                  <el-amap-search-box
                      class="search-box"
                      :search-option="searchOption"
                      :on-search-result="onSearchResult"
                      aria-placeholder="123456"
                  ></el-amap-search-box>
                  <el-amap
                      vid="amapDemo"
                      :center="center"
                      :zoom="16"
                      class="amap-demo"
                      :events="events"
                  >
                    <el-amap-marker v-for="(marker,i) in markers" :position="marker"
                                    :key="i"></el-amap-marker>
                  </el-amap>
                </div>
                <span style="color:red">友情提示:放大地图点击可精准定位!</span>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="48">
            <a-col :md="48" :sm="24">
              <a-form-item
                  :labelCol="{
          xs: { span: 12 },
          sm: { span: 4 }}"
                  :wrapperCol="{
          xs: { span: 24 },
          sm: { span: 12 }}"
                  label="内容"
                  hasFeedback
              >
                <UEditor ref="ue" style="height:520px;" :visible="visible" :content="formData.content"
                         :ueditorContent.sync="formData.content"></UEditor>
              </a-form-item>
            </a-col>
          </a-row>

        </a-form>

      </a-spin>
      <template slot="footer">
        <a-button key="cancel" @click="handleCancel">取消</a-button>
        <a-button key="forward" :loading="saveLoading" type="primary" @click="handleOk">保存</a-button>
      </template>
    </a-modal>


    <a-modal
        title="评论管理"
        :width="1000"
        style="top: 20px;"
        :bodyStyle="{maxHeight:'500px','overflowY':'scroll'}"
        v-model="commentVisible"
        @ok="commentVisible=false"
    >
      <a-spin :spinning="saveLoading">
        <a-form :form="form">
          <a-table :columns="commentColumns" :dataSource="commentList" :pagination="commentPagination"
                   @change="handleCommentTableChange"
                   rowKey="id" :scroll="{ y: 300 }" bordered>
            <div slot="filterDropdown"
                 slot-scope="{ setSelectedKeys, selectedKeys, confirm, clearFilters, column }"
                 class='custom-filter-dropdown'>
              <a-input
                  v-model="commentQuery.keywords"
                  placeholder="搜索姓名"
                  style="width: 188px; margin-bottom: 8px; display: block;"
              />
              <a-button
                  type='primary'
                  @click="commentSearch(selectedKeys, confirm)"
                  icon="search"
                  size="small"
                  style="width: 90px; margin-right: 8px"
              >搜索
              </a-button>
              <a-button
                  @click="commentSearchReset(selectedKeys, confirm)"
                  size="small"
                  style="width: 90px"
              >重置
              </a-button>
            </div>
            <span slot="name" slot-scope="text,record">
              {{ record.user_name }}
            </span>
            <span slot="action" slot-scope="text,record">
              <template>
                <a-popconfirm title="删除后不可恢复,确定删除吗?" @confirm="onCommentDelete(record)" okText="确定" cancelText="取消">
                  <a href="javascript:;">删除</a>
                </a-popconfirm>
              </template>
            </span>
          </a-table>
        </a-form>
      </a-spin>
    </a-modal>
  </a-card>
</template>

<script>
import STable from '@/components/table/'
import ATextarea from 'ant-design-vue/es/input/TextArea'
import AInput from 'ant-design-vue/es/input/Input'
import EditableCell from '@/components/EditableCell/'
import UEditor from '@/components/UEditor/'
import PicUploader from '@/components/PicUploader/'
import VideoUploader from '@/components/VideoUploader/'
import FileUploader from '@/components/FileUploader/'
import RSwitch from '@/components/RSwitch/'
import areaOptions from '@/utils/area'
import UserPicker from '@/components/UserPicker/'
import UrlPicker from '@/components/UeditorUrlPicker/'
import moment from 'moment'
import 'moment/locale/zh-cn';

moment.locale('zh-cn');
import {getCityOption} from '@/api/utils'

import {
  getTopicList,
  getTopicDetail,
  editTopic,
  getActivityOptions,
  addTopic,
  deleteTopic,
  setRank,
  setTopicStatus,
  setTopicAllStatus,
  getCommentList,
  deleteComment
} from '@/api/topic'

import {getGoodsOptions} from '@/api/goods'

export default {
  name: 'TourTopicList',
  components: {
    AInput,
    ATextarea,
    FileUploader,
    PicUploader,
    VideoUploader,
    STable,
    RSwitch,
    UEditor,
    UrlPicker,
    EditableCell,
    UserPicker
  },
  data() {
    let that = this
    return {
      lng: 118.7982559204,
      lat: 32.0857743123,
      markers: [],
      searchOption: {
        city: '南京',
        citylimit: false
      },
      // mapCenter: [121.59996, 31.197646],

      center: [32.0857743123, 118.7982559204],
      events: {
        init: o => {
          console.log(o.getCenter())
          // console.log(this.$refs.map.$$getInstance());
          o.getCity(result => {
            console.log(result)
          })
        },
        moveend: () => {
        },
        zoomchange: () => {
        },
        click: e => {
          that.markers = []
          that.center = [e.lnglat.lng, e.lnglat.lat] //点击选择新地址为中心点
          that.lng = e.lnglat.lng
          that.lat = e.lnglat.lat
          that.markers.push([e.lnglat.lng, e.lnglat.lat])
          console.log(that.center)
          console.log(that.markers)
          console.log(that.lng, that.lat)
        }
      },
      plugin: [
        'ToolBar',
        {
          pName: 'MapType',
          defaultType: 0,
          events: {
            init(o) {
              console.log(o)
            }
          }
        }
      ],
      areaOptions,
      visible: false,
      saveLoading: false,
      subjectTypeOptions: [],
      commentList: [],
      cityOptions: [],
      formData: {
        id: 0,
        activity_id: [],
        goods_ids: [],
        label: [],
        status: 1,
        type: 1,
        content: '',
        user_id: '',
        reward_price: 0,
        areas: [],
        pic: [],
        video: [],
        pics: [],
        vr_pic: [],
      },
      rewardOptions: [
        {id: 1, title: 100},
        {id: 2, title: 200},
        {id: 3, title: 300},
      ],
      labelOptions: [
        {id: 1, title: '生鲜'},
        {id: 2, title: '特产'},
        {id: 3, title: '内蛋奶'},
        {id: 4, title: '乡土美食'},
        {id: 4, title: '精品线路'},
        {id: 4, title: '直播VR'},

      ],
      activityOptions: [],
      goodsOptions: [],
      labelCol: {
//          xs: { span: 24 },
//          sm: { span: 5 },
        xs: {span: 24},
        sm: {span: 8},
      },
      mapLabelCol: {
        xs: {span: 24},
        sm: {span: 4},
      },
      wrapperCol: {
        xs: {span: 24},
        sm: {span: 12},
      },
      form: this.$form.createForm(this),
      mdl: {},

      // 高级搜索 展开/关闭
      advanced: false,
      // 查询参数
      queryParam: {
        keywords: '',
      },
      // 表头
      columns: [
        {
          title: '#',
          dataIndex: 'id',
          width: '80px'
        },
        {
          title: '名称',
          dataIndex: 'name',
          scopedSlots: {customRender: 'name'},
        },
        {
          title: '所属活动',
          width: '200px',
          dataIndex: 'activity_title',
        },
        {
          title: '发布者',
          width: '120px',
          dataIndex: 'user',
          scopedSlots: {customRender: 'user'},
        },
        {
          title: '排序',
          width: '140px',
          dataIndex: 'rank',
          scopedSlots: {customRender: 'rank'},
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: 200,
          scopedSlots: {customRender: 'action'},
        }
      ],
      // 加载数据方法 必须为 Promise 对象
      loadData: parameter => {
        console.log('loadData');
        console.log(this.queryParam);

        this.queryParam = Object.assign(this.queryParam, parameter);
        return getTopicList(this.queryParam)
            .then(res => {
              this.topicList = res.data.list

              console.log('res', this.topicList);
              return res.data
            })
      },

      selectedRowKeys: [],
      selectedRows: [],
      commentVisible: false,

      //领取人员表头
      commentColumns: [
        {
          title: '#',
          dataIndex: 'id',
          width: '100px'
        },
        {
          title: '用户名',
          dataIndex: 'user_name',
          width: '150px',
          scopedSlots: {
            filterDropdown: 'filterDropdown',
            filterIcon: 'filterIcon',
            customRender: 'name',
          }
        },
        {
          title: '内容',
          width: '150px',
          dataIndex: 'content'
        },
        {
          title: '发布时间',
          width: '150px',
          dataIndex: 'create_time',
          customRender: (text) => {
            return moment(text * 1000).format('YYYY-MM-DD HH:mm:ss');
          }
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: 200,
          scopedSlots: {customRender: 'action'},
        }
      ],
      commentPagination: {},
      commentQuery: {
        kaoji_id: 0,
        status: 0,
        page: 1,
        keywords: undefined
      },

      //单个服务
      menuRow: {
        url: {},
        urlVisible: false
      },
      serviceRow: {},

      topicList: [],
      area_key: []
    }
  },
  computed: {},
  created() {
  },

  mounted() {
    let that = this;
    that.getActivityOptions();
    that.getGoodsOptions();
    that.getCityData()
  },
  methods: {
    moment,
    addHandle() {
      this.markers = []
      // this.markers.push([118.7982559204, 32.0857743123])
      this.center = [118.7982559204, 32.0857743123]
      this.formData = {
        id: 0,
        activity_id: [],
        goods_ids: [],
        label: [],
        user_id: '',
        desc: '',
        type: 1,
        location_name: '',
        can_comment: 1,
        reward_price: 0,
        content: '',
        pic: [],
        video: [],
        pics: [],
        vr_pic: [],
        lng: this.lng,
        lat: this.lat
      },
          this.form.resetFields();
      this.visible = true
    },
    handleCancel() {
      this.visible = false
    },
    getActivityOptions() {
      let that = this;
      getActivityOptions().then(res => {
        that.activityOptions = res.data.list
      })
    },

    getCityData() {
      let that = this
      getCityOption({}).then(res => {
        let list = []
        res.data.map(row => {
          if (row.label == '江苏省') {
            list.push(row)
          }
          that.cityOptions = list
        })
      })
    },

    getGoodsOptions() {
      let that = this;
      getGoodsOptions().then(res => {

        that.goodsOptions = res.data.list
      })
    },
    //展开关闭
    toggleAdvanced() {
      this.advanced = !this.advanced
    },

    handleEdit(record) {
      let self = this
      this.visible = true
      getTopicDetail({id: record.id}).then(res => {
        setTimeout(() => {
          self.form.setFieldsValue({...res.data})
          self.formData.id = record.id;
          console.log('handleEdit')
          self.formData = {...res.data};

          self.center = [res.data.lng, res.data.lat]
          self.markers = [[res.data.lng, res.data.lat]]
          // self.searchOption.city = res.data.city
        }, 200)
      })
      // console.log(this.mdl)
    },
    // 查
    onSearch() {
      let self = this;
      this.queryParam.area_key=this.area_key[this.area_key.length-1]
      self.$refs.table.refresh(true)
    },
    // 增改 处理
    handleOk(e) {
      let self = this;
      if (!self.formData.activity_id.length) {
        self.$message.error('请选择活动板块');
        return;
      }

      // if (!self.formData.user_id) {
      //   self.$message.error('请选择发布用户')
      //   return;
      // }

      if (!self.markers.length) {
        self.$message.error('请在地图上标注位置')
        return;
      }

      e.preventDefault()
      this.form.validateFields((err, values) => {
        if (!err) {
          console.log('Received values of form: ', values)
          console.log('Received valuess of formData: ', self.formData)
          self.saveLoading = true;
          if (self.formData.id > 0) {
            editTopic({
              id: self.formData.id,
              title: values.title,
              desc: values.desc,
              location_name: values.location_name,
              type: self.formData.type,
              url: values.url,
              content: self.formData.content,
              pics: self.formData.pics,
              vr_pic: self.formData.vr_pic,
              video: self.formData.video,
              user_id: self.formData.user_id,
              can_comment: self.formData.can_comment,
              activity_id: self.formData.activity_id,
              goods_ids: self.formData.goods_ids,
              label: self.formData.label,
              reward_price: self.formData.reward_price,
              lng: self.markers[0][0],
              lat: self.markers[0][1]
            }).then(res => {
              self.$message.success('修改成功')
              self.$refs.table.refresh(false)
              self.visible = false;
              self.saveLoading = false;
            }).catch(err => {
              self.$message.error(err.data.msg);
              self.saveLoading = false;
            })
          } else {
            addTopic({
              activity_id: self.formData.activity_id,
              title: values.title,
              desc: values.desc,
              location_name: values.location_name,
              type: self.formData.type,
              content: self.formData.content,
              url: values.url,
              pics: self.formData.pics,
              vr_pic: self.formData.vr_pic,
              video: self.formData.video,
              user_id: self.formData.user_id,
              goods_ids: self.formData.goods_ids,
              label: self.formData.label,
              can_comment: self.formData.can_comment,
              reward_price: self.formData.reward_price,
              lng: self.markers[0][0],
              lat: self.markers[0][1]
            }).then(res => {
              self.$message.success('修改成功')
              self.$refs.table.refresh(false)
              self.visible = false;
              self.saveLoading = false;
            }).catch(err => {
              self.$message.error(err.data.msg);
              self.saveLoading = false;
            })
          }

        }
      })
    },

    onSearchResult(pois) {
      let latSum = 0
      let lngSum = 0
      console.log(pois)
      if (pois.length > 0) {
        pois.forEach(poi => {
          let {lng, lat} = poi
          lngSum += lng
          latSum += lat
          this.markers.push([poi.lng, poi.lat])
        })
        let center = {
          lng: lngSum / pois.length,
          lat: latSum / pois.length
        }
        this.center = [center.lng, center.lat]
      }
    },

    onDelete(record) {
      let self = this;
      deleteTopic({
        id: record.id
      }).then(res => {
        self.$message.success('删除成功')
        self.$refs.table.refresh()
      }).catch(err => {
        self.$message.error(err.data.msg);
      })
    },

    setStatus(record, status) {
      let self = this
      setTopicStatus({
        id: record.id,
        status: status,
      })
          .then(res => {
            record.status = status
            self.$message.success('设置成功')
            // self.$refs.table.refresh(true)
          })

    },

    setAllStatus(status) {
      let self = this;
      setTopicAllStatus({
        ids: self.selectedRowKeys,
        status: status,
      })
          .then(res => {
            self.topicList.map(row => {
              self.selectedRowKeys.map(key => {
                if(key == row.id) {
                  row.status =status
                }
              })

            })

            self.selectedRowKeys = []

            self.$message.success('设置成功')
            // self.$refs.table.refresh(true)
          })
    },
    download() {
      getDownloadUrl(this.queryParam).then(res => {
        console.log(res);
        window.open(res.data);
      })
    },
    onRankChange(key, dataIndex, value) {
      let self = this;
      setRank({
        id: key,
        rank: value
      }).then(res => {
        self.$refs.table.refresh(true)
      }).catch(err => {
        self.$message.error(err.data.msg)
      })
    },


    handleCommentManage(record) {
      let self = this
      self.commentQuery.topic_id = record.id;
      self.commentQuery.keywords = undefined;
      self.commentQuery.status = undefined;
      self.commentPagination.page = 1;
      self.fetchCommentList();
      this.commentVisible = true
    },


    fetchCommentList() {
      let self = this
      getCommentList(Object.assign(self.commentQuery, self.commentPagination)).then(res => {
        self.commentList = res.data.list
        self.commentPagination.total = res.data.total
      })
    },

    commentSearch(selectedKeys, confirm) {
      let self = this
      confirm();
      self.fetchCommentList();
    },
    commentSearchReset(selectedKeys, confirm) {
      let self = this;
      confirm();
      self.commentQuery.keywords = undefined;
      self.fetchCommentList();
    },
    handleCommentTableChange(pagination, filters, sorter) {
      console.log('filters', filters);
      let that = this;
      const pager = {...this.pagination};
      pager.current = pagination.current;
      that.pagination = pager;
      that.commentQuery.page = pagination.current;
      that.fetchCommentList();
    },


    onCommentDelete(record) {
      let self = this;
      deleteComment({
        id: record.id
      }).then(res => {
        self.$message.success('删除成功')
        self.fetchCommentList();
      }).catch(err => {
        self.$message.error(err.data.msg);
      })
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
    },

  },
  filters: {},
}
</script>
<style scoped>
.custom-filter-dropdown {
  padding: 8px;
  border-radius: 4px;
  background: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .15);
}

.highlight {
  background-color: rgb(255, 192, 105);
  padding: 0px;
}

.content-map {
  height: 300px;
}

.amap-demo {
  height: 300px;
}

.search-box {
  position: absolute;
  top: 25px;
  left: 20px;
  width: 70%;
}

.amap-page-container {
  position: relative;
}
</style>
